/* eslint-disable no-console */
let store = null;

const getState = () => {
  if (!store) {
    console.warn('Attempting to access store before it is set.');
  }

  return store && store.getState();
};

const getStore = () => {
  if (!store) {
    console.warn('Attempting to access store before it is set.');
  }

  return store;
};

const setStore = (newStore) => {
  store = newStore;
};

export {
  getState,
  getStore,
  setStore,
};

export default {
  getState,
  getStore,
  setStore,
};
